import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import { hachureLinesForPolygon, hachureLinesForEllipse, lineLength } from './filler-utils';
export var DotFiller =
/*#__PURE__*/
function () {
  function DotFiller(renderer) {
    _classCallCheck(this, DotFiller);

    this.renderer = renderer;
  }

  _createClass(DotFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      o = Object.assign({}, o, {
        curveStepCount: 4,
        hachureAngle: 0
      });
      var lines = hachureLinesForPolygon(points, o);
      return this.dotsOnLines(lines, o);
    }
  }, {
    key: "fillEllipse",
    value: function fillEllipse(cx, cy, width, height, o) {
      o = Object.assign({}, o, {
        curveStepCount: 4,
        hachureAngle: 0
      });
      var lines = hachureLinesForEllipse(cx, cy, width, height, o, this.renderer);
      return this.dotsOnLines(lines, o);
    }
  }, {
    key: "dotsOnLines",
    value: function dotsOnLines(lines, o) {
      var ops = [];
      var gap = o.hachureGap;

      if (gap < 0) {
        gap = o.strokeWidth * 4;
      }

      gap = Math.max(gap, 0.1);
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;
          var length = lineLength(line);
          var dl = length / gap;
          var count = Math.ceil(dl) - 1;
          var alpha = Math.atan((line[1][1] - line[0][1]) / (line[1][0] - line[0][0]));

          for (var i = 0; i < count; i++) {
            var l = gap * (i + 1);
            var dy = l * Math.sin(alpha);
            var dx = l * Math.cos(alpha);
            var c = [line[0][0] - dx, line[0][1] + dy];
            var cx = this.renderer.getOffset(c[0] - gap / 4, c[0] + gap / 4, o);
            var cy = this.renderer.getOffset(c[1] - gap / 4, c[1] + gap / 4, o);
            var ellipse = this.renderer.ellipse(cx, cy, fweight, fweight, o);
            ops = ops.concat(ellipse.ops);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        type: 'fillSketch',
        ops: ops
      };
    }
  }]);

  return DotFiller;
}();